// angular
//     .module("HeroPRO")
//     .controller("GetSignaturesWalkthroughController", getSignaturesWalkthroughController);

/* @ngInject */
export default function GetSignaturesWalkthroughController($stateParams, EDocumentsFactory, $window, AuthenticationFactory, $scope, FRInformationFactory, HPStateMachineConfig, FRDocumentsFactory, raSpinnerService) {
    const vm = this;
    vm.stateMachineData = {};
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.showGetSignaturesButton = false;

    init();

    vm.signNow = function () {
        raSpinnerService.show('walkthroughSpinner');
        EDocumentsFactory.getDocusignLink($stateParams.appId, 'CompletionCertificate').then((data) => {
            AuthenticationFactory.stopAuthenticationInterval();
            $window.location.href = data.data.returnUrl;
        });
    };

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
        });

        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(() => {
            vm.showGetSignaturesButton = FRDocumentsFactory.getSignaturesButtonVisibility();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/getPaid/getSignaturesWalkthroughController.js